export enum Bound {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}

export type ChartEntry = {
  activeLiquidity: number;
  price: number;
  tick?: number;
  amount0Locked?: number;
  amount1Locked?: number;
};

export type Dimensions = {
  width: number;
  height: number;
};

export type Margins = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export type ZoomLevels = {
  initialMin: number;
  initialMax: number;
  min: number;
  max: number;
};

export type AllV3TicksQuery = {
  __typename?: 'Query';
  ticks: {
    __typename?: 'Tick';
    liquidityNet: unknown;
    price0: unknown;
    price1: unknown;
    tick: unknown;
  }[];
};

export type Ticks = NonNullable<NonNullable<AllV3TicksQuery>['ticks']>;
export type TickData = Ticks[number];
